import React from 'react';
import { Link as v4Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

// lodash
import map from 'lodash/map';

// awesome styled grid
import { Row } from '@zillow/zrs-comet';

// rmw context
import { RMWContext } from 'app/shared/providers/RMWContext';

// utils
import accessUtils from 'app/shared/utils/accessUtils';

// selectors
import { AppSelectors, UserSelectors } from 'app/shared/selectors';

// components
import PropertyCard from 'app/shared/components/properties/PropertyCard';
import SOHPropertyCard from 'app/shared/components/soh/PropertyCard';

// styles
import { StyledCol } from './StyledComponents';

const PropertiesViewGrid = (props) => {
    const getContext = () => RMWContext.Consumer._currentValue;
    const { brand } = getContext();

    const {
        cookieEnabledServices,
        dispatch,
        isSOH,
        listings,
        user,
    } = props;

    const { features, paymentsAccessAllowed } = user;
    const { canAccessContacts, canAccessAnalytics } = features;

    return (
        <Row
            className="PropertiesViewGrid"
        >
            {
                map(listings, (listingModel, index) => {
                    const {
                        feedId,
                        feedListingId,
                        isEditable,
                        restrictions,
                        state,
                    } = listingModel;

                    const canAccessApplicationsResponse = accessUtils.canAccessApplications({
                        brand,
                        restrictions,
                        cookieEnabledServices,
                        groupState: state,
                    });

                    const canAccessPayments = accessUtils.canAccessPayments({
                        brand,
                        restrictions,
                        cookieEnabledServices,
                        paymentsAccessAllowed,
                    });

                    const canAccessLeases = accessUtils.canAccessLeases(restrictions);

                    const hdpUrl = `/listing/${feedListingId}_${feedId}`;

                    return (
                        <StyledCol
                            className="PropertiesDisplay-StyledCol"
                            xs={12}
                            lg={6}
                            xl={4}
                            key={index}
                        >
                            <LazyLoad
                                height={262}
                                once={true}
                            >
                                {isSOH ? (
                                    <SOHPropertyCard
                                        key={feedListingId}
                                        listing={listingModel}
                                    />
                                ) : (
                                    <PropertyCard
                                        reactRouterLink={v4Link}
                                        key={feedListingId}
                                        hdpUrl={hdpUrl}
                                        isFeedFromHost={isEditable}
                                        isSOH={isSOH}
                                        listing={listingModel}
                                        canAccessApplications={canAccessApplicationsResponse}
                                        canAccessPayments={canAccessPayments}
                                        canAccessLeases={canAccessLeases}
                                        canAccessContacts={canAccessContacts}
                                        canAccessAnalytics={canAccessAnalytics}
                                        dispatch={dispatch}
                                    />
                                )}
                            </LazyLoad>
                        </StyledCol>
                    );
                })
            }
        </Row>
    );
};

PropertiesViewGrid.propTypes = {
    listings: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
    user: UserSelectors.makeUser(state),
    cookieEnabledServices: AppSelectors.makeCookieEnabledServices(state),
    isSOH: AppSelectors.makeIsSOH(state),
});

export { PropertiesViewGrid };
export default connect(mapStateToProps)(PropertiesViewGrid);
